import * as Y from "yjs";
import { WebsocketProvider } from "y-websocket";

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

const nameInput = document.getElementById("name-input");
const colorInput = document.getElementById("color-input");
const ctaContinue = document.getElementById("intro-cta-continue");
const cta = document.getElementById("intro-cta");
const clear = document.getElementById("clear-collab");
const container = document.getElementById("collab");
const task = document.getElementById("collab-task");
const usersContainer = document.getElementById("collab-users");

nameInput.addEventListener("change", () => {
  if (nameInput.value.length > 1) {
    cta.disabled = false;
    ctaContinue.disabled = false;
  } else {
    cta.disabled = true;
    ctaContinue.disabled = true;
  }
});

const markers = new Map();

export const startCollab = (G) => {
  const ydoc = new Y.Doc({ guid: "pmop" });
  // clients connected to the same room-name share document updates
  const provider = new WebsocketProvider(
    "wss://playful-misuse-of-place-431931398078.europe-west3.run.app",
    "playful-misuse-of-place",
    ydoc,
  );

  const ymap = ydoc.getMap("pastes");
  const ytask = ydoc.getText("task");

  ydoc.on("update", (update, origin) => {
    console.log(
      `\n[Doc Update Event] Received binary update byte stream (${update.byteLength} bytes) from origin:`,
      origin,
    );
  });

  const awareness = provider.awareness;

  // You can observe when a user updates their awareness information
  awareness.on("change", () => {
    // Whenever somebody updates their awareness information,
    // we log all awareness information from all users.
    usersContainer.innerHTML = "";

    for (const { user } of awareness.getStates().values()) {
      const entry = document.createElement("div");
      entry.style.background = `#${user.color ?? "0f0"}`;
      if (user.name === nameInput.value) {
        entry.innerText = `✴️ ${user.name}`;
      } else {
        entry.innerText = `✨ ${user.name}`;
      }
      usersContainer.appendChild(entry);

      const marker = markers.get(user.name);
      if (!marker) {
        markers.set(
          user.name,
          new google.maps.Marker({
            title: user.name,
            position: user.position,
            map: G.map,
            icon: `data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100%22%20height%3D%22100%22%20viewBox%3D%220%200%20124%20124%22%20fill%3D%22none%22%3E%3Cstyle%3E%20%20.text%20%7B%20%20%20%20font%3A%20bold%2030px%20monospace%3B%20%20text-align%3A%20center%3B%20%20%7D%3C%2Fstyle%3E%3Crect%20width%3D%22124%22%20height%3D%22124%22%20rx%3D%22124%22%20fill%3D%22%23${user.color ?? "0f0"}%22%2F%3E%3Ctext%20x%3D%2220%22%20y%3D%2270%22%20fill%3D%22black%22%20class%3D%22text%22%20textLength%3D%2290%22%3E${user.name}%3C%2Ftext%3E%3C%2Fsvg%3E`,
          }),
        );
      } else {
        marker.setPosition(user.position);
      }
    }
  });

  // You can think of your own awareness information as a key-value store.
  // We update our "user" field to propagate relevant user information.
  const position = G.map.getPosition();

  awareness.setLocalStateField("user", {
    // Define a print name that should be displayed
    name: nameInput.value,
    position: {
      lat: position.lat(),
      lng: position.lng(),
    },
    color: colorInput.value.replace("#", ""),
  });

  G.map.addListener("position_changed", () => {
    const position = G.map.getPosition();

    awareness.setLocalStateField("user", {
      // Define a print name that should be displayed
      name: nameInput.value,
      color: colorInput.value.replace("#", ""),
      position: {
        lat: position.lat(),
        lng: position.lng(),
      },
    });
  });

  ymap.observe((event) => {
    const figures = Array.from(container.getElementsByTagName("figure"));
    for (const figure of figures) {
      container.removeChild(figure);
    }

    for (const key of ymap.keys()) {
      const url = ymap.get(key);
      const image = new Image();
      image.src = url;

      const wrapper = document.createElement("figure");
      const caption = document.createElement("figcaption");
      caption.innerText = key;
      wrapper.appendChild(image);
      wrapper.appendChild(caption);
      container.insertBefore(wrapper, container.firstElementChild);
    }
  });

  document.addEventListener("paste", async (event) => {
    const items = await navigator.clipboard.read();
    console.log("paste!", items, event.clipboardData);
    const imageItems = items.filter((d) =>
      d.types.some((t) => t.startsWith("image")),
    );
    const first = imageItems.at(0);
    if (!first) return;

    const type = first.types.find((t) => t.startsWith("image"));
    const blob = await first?.getType(type);
    if (!blob) return;

    console.log("got blob", blob, first, type);

    const url = await blobToBase64(blob);
    ymap.set(nameInput.value, url);
  });

  ytask.observe(() => {
    task.innerText = ytask.toString();
  });

  window.setTask = (t) => ytask.insert(0, t);

  clear.addEventListener("click", () => {
    ymap.clear();
    ytask.delete(0, ytask.toString().length);
  });
};
